export default {
  currentPage(state, value) {
    return (state.currentPage = value);
  },

  perPage(state, value) {
    return (state.perPage = value);
  },

  loanTypesTotal(state, value) {
    return (state.loanTypesTotal = value);
  },

  loanTypes(state, value) {
    return (state.loanTypes = value);
  },

  searchQuery(state, value) {
    return (state.searchQuery = value);
  },

  tableLoading(state, value) {
    return (state.tableLoading = value);
  },

  loanRequestsTotal(state, value) {
    return (state.loanRequestsTotal = value);
  },
  loanRequests(state, value) {
    return (state.loanRequests = value);
  },
  loanRequestsCurrentPage(state, value) {
    return (state.loanRequestsCurrentPage = value);
  },
  loanRequestsPerPage(state, value) {
    return (state.loanRequestsPerPage = value);
  },
  loanRequestsApprovalTotal(state, value) {
    return (state.loanRequestsApprovalTotal = value);
  },
  loanRequestsApproval(state, value) {
    return (state.loanRequestsApproval = value);
  },
  loanRequestsApprovalCurrentPage(state, value) {
    return (state.loanRequestsApprovalCurrentPage = value);
  },
  loanRequestsApprovalPerPage(state, value) {
    return (state.loanRequestsApprovalPerPage = value);
  },
};
